'<template>
   <div class="page_member_join_container">
      <div class="max_width">
         <div class="container_nav">
            当前位置：<router-link to="/">首页 - </router-link><a>专题申报</a>
         </div>
         <div class="table_content">
            <el-table :data="list" v-loading="loading" stripe>
               <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
               <el-table-column   label="活动名称">
                  <template slot-scope="scope">
                     <router-link :to="'/user/member/info/'+scope.row.code">{{scope.row.title}}</router-link>
                  </template>
               </el-table-column>
               <el-table-column label="活动日期">
                  <template slot-scope="scope">
                     {{scope.row.startTime}} ~ {{scope.row.endTime}}
                  </template>
               </el-table-column>
               <!--<el-table-column label="操作记录">
                  <template slot-scope="scope">
                     {{scope.row.isJoin == 'Y' ?'已上传资料':'无'}}
                  </template>
               </el-table-column>
               <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                  <template v-if="scope.row.status  == 1">
                     <el-upload action="" :multiple="true" list-type="text" :file-list="fileList" :auto-upload="true" :limit="fileNum" :show-file-list="false" action="" :http-request="handleUpload" ref="sdsupload" :on-preview="handlePictureCardPreview" :on-exceed="onExceed">
                        <a href="javascript:;" class="uploud_btn" @click="listActive = index">上传资料</a>
                     </el-upload>
                  </template>
                  <a :href="scope.row.documentFile" class="down_btn" v-if="scope.row.isJoin == 'Y'">下载资料</a>
                  </template>
               </el-table-column>-->
            </el-table>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   import {
      getCookie,
      delCookie,
      setCookie
   } from '@/assets/js/util'; // cookie操作
   export default {
      name: 'zhuanti_join_page',
      components: {},
      data() {
         return {
            loading: false,


            //活动列表
            list: [],
            pageNum: 1,
            pageSize: 10,
            pagecount: 10,

            centerDialogVisible: false, //弹框
            listActive: 0, //选中的上传列表
            fileList: [],
            fileNum: 1, //文件上传个数
            uploadbox: '', //上传文件地址
         };
      },
      mounted() {
         this.getlist();
      },
      methods: {
         init() {
            var _this = this;

         },
         getlist() {
            var _this = this;
            _this.loading = true;
            _this.$api.activityList({
               token: getCookie('sd_token'),
               pageNum: _this.pageNum,
               pageSize: _this.pageSize
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.list = res.data.list;
                  _this.pagecount = res.data.total;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
         handleCurrentChange(val) {
            this.pageNum = val;
            this.getlist();
         },
      }
   }
</script>
<style lang="less">

</style>
